const TRIGGER_SUGGEST = {
  id: "editor.action.triggerSuggest",
  title: ""
};

export { TRIGGER_SUGGEST };
//# sourceMappingURL=commands.js.map
